export default __webpack_public_path__ + "static/media/visuel-home-zoom-2-min.59b214e2.jpg";